import client from 'data/client';
import { CDError } from 'utils/error';

export type ResponseStatus = {
  status: string;
};

export const testPrinter = async () => {
  try {
    const { data } = await client.post<ResponseStatus>(`/printer/test`);
    return data;
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
